import { getUsersNotesListQueryOptions } from "@sidegigllc/api/client";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { proId: number };

export const notesQuery = ({ proId }: QueriesInput) => getUsersNotesListQueryOptions(proId);

export const queries = (input: QueriesInput): Array<WarmableQuery> => [notesQuery(input)];
